export const paymentMethods = [
    {key: 'BANK', value: 'Banco'},
    {key: 'COLLECTOR', value: 'Cobrador'},
    {key: 'RECEIPT', value: 'Recibo'},
];

export const paymentMethodsObject = {
    'BANK': 'Banco',
    'COLLECTOR': 'Cobrador',
    'RECEIPT': 'Recibo',
};